import React, { createContext, useContext } from "react";
import useTenantTheme from "../Hooks/useTenantTheme";

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const tenantTheme = useTenantTheme();
  return (
    <ThemeContext.Provider value={tenantTheme}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
